"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createStyleFunction = createStyleFunction;
exports["default"] = void 0;

var _Object = _interopRequireDefault(require("./Object.js"));

var _EventType = _interopRequireDefault(require("./events/EventType.js"));

var _asserts = require("./asserts.js");

var _events = require("./events.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/Feature
 */


/**
 * @typedef {typeof Feature|typeof import("./render/Feature.js").default} FeatureClass
 */

/**
 * @typedef {Feature|import("./render/Feature.js").default} FeatureLike
 */

/***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<import("./ObjectEventType").Types|'change:geometry', import("./Object").ObjectEvent, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|import("./ObjectEventType").Types
 *     |'change:geometry', Return>} FeatureOnSignature
 */

/***
 * @template Geometry
 * @typedef {Object<string, *> & { geometry?: Geometry }} ObjectWithGeometry
 */

/**
 * @classdesc
 * A vector object for geographic features with a geometry and other
 * attribute properties, similar to the features in vector file formats like
 * GeoJSON.
 *
 * Features can be styled individually with `setStyle`; otherwise they use the
 * style of their vector layer.
 *
 * Note that attribute properties are set as {@link module:ol/Object~BaseObject} properties on
 * the feature object, so they are observable, and have get/set accessors.
 *
 * Typically, a feature has a single geometry property. You can set the
 * geometry using the `setGeometry` method and get it with `getGeometry`.
 * It is possible to store more than one geometry on a feature using attribute
 * properties. By default, the geometry used for rendering is identified by
 * the property name `geometry`. If you want to use another geometry property
 * for rendering, use the `setGeometryName` method to change the attribute
 * property associated with the geometry for the feature.  For example:
 *
 * ```js
 *
 * import Feature from 'ol/Feature';
 * import Polygon from 'ol/geom/Polygon';
 * import Point from 'ol/geom/Point';
 *
 * var feature = new Feature({
 *   geometry: new Polygon(polyCoords),
 *   labelPoint: new Point(labelCoords),
 *   name: 'My Polygon'
 * });
 *
 * // get the polygon geometry
 * var poly = feature.getGeometry();
 *
 * // Render the feature as a point using the coordinates from labelPoint
 * feature.setGeometryName('labelPoint');
 *
 * // get the point geometry
 * var point = feature.getGeometry();
 * ```
 *
 * @api
 * @template {import("./geom/Geometry.js").default} [Geometry=import("./geom/Geometry.js").default]
 */
var Feature =
/** @class */
function (_super) {
  __extends(Feature, _super);
  /**
   * @param {Geometry|ObjectWithGeometry<Geometry>} [opt_geometryOrProperties]
   *     You may pass a Geometry object directly, or an object literal containing
   *     properties. If you pass an object literal, you may include a Geometry
   *     associated with a `geometry` key.
   */


  function Feature(opt_geometryOrProperties) {
    var _this = _super.call(this) || this;
    /***
     * @type {FeatureOnSignature<import("./events").EventsKey>}
     */


    _this.on;
    /***
     * @type {FeatureOnSignature<import("./events").EventsKey>}
     */

    _this.once;
    /***
     * @type {FeatureOnSignature<void>}
     */

    _this.un;
    /**
     * @private
     * @type {number|string|undefined}
     */

    _this.id_ = undefined;
    /**
     * @type {string}
     * @private
     */

    _this.geometryName_ = 'geometry';
    /**
     * User provided style.
     * @private
     * @type {import("./style/Style.js").StyleLike}
     */

    _this.style_ = null;
    /**
     * @private
     * @type {import("./style/Style.js").StyleFunction|undefined}
     */

    _this.styleFunction_ = undefined;
    /**
     * @private
     * @type {?import("./events.js").EventsKey}
     */

    _this.geometryChangeKey_ = null;

    _this.addChangeListener(_this.geometryName_, _this.handleGeometryChanged_);

    if (opt_geometryOrProperties) {
      if (typeof
      /** @type {?} */
      opt_geometryOrProperties.getSimplifiedGeometry === 'function') {
        var geometry =
        /** @type {Geometry} */
        opt_geometryOrProperties;

        _this.setGeometry(geometry);
      } else {
        /** @type {Object<string, *>} */
        var properties = opt_geometryOrProperties;

        _this.setProperties(properties);
      }
    }

    return _this;
  }
  /**
   * Clone this feature. If the original feature has a geometry it
   * is also cloned. The feature id is not set in the clone.
   * @return {Feature<Geometry>} The clone.
   * @api
   */


  Feature.prototype.clone = function () {
    var clone =
    /** @type {Feature<Geometry>} */
    new Feature(this.hasProperties() ? this.getProperties() : null);
    clone.setGeometryName(this.getGeometryName());
    var geometry = this.getGeometry();

    if (geometry) {
      clone.setGeometry(
      /** @type {Geometry} */
      geometry.clone());
    }

    var style = this.getStyle();

    if (style) {
      clone.setStyle(style);
    }

    return clone;
  };
  /**
   * Get the feature's default geometry.  A feature may have any number of named
   * geometries.  The "default" geometry (the one that is rendered by default) is
   * set when calling {@link module:ol/Feature~Feature#setGeometry}.
   * @return {Geometry|undefined} The default geometry for the feature.
   * @api
   * @observable
   */


  Feature.prototype.getGeometry = function () {
    return (
      /** @type {Geometry|undefined} */
      this.get(this.geometryName_)
    );
  };
  /**
   * Get the feature identifier.  This is a stable identifier for the feature and
   * is either set when reading data from a remote source or set explicitly by
   * calling {@link module:ol/Feature~Feature#setId}.
   * @return {number|string|undefined} Id.
   * @api
   */


  Feature.prototype.getId = function () {
    return this.id_;
  };
  /**
   * Get the name of the feature's default geometry.  By default, the default
   * geometry is named `geometry`.
   * @return {string} Get the property name associated with the default geometry
   *     for this feature.
   * @api
   */


  Feature.prototype.getGeometryName = function () {
    return this.geometryName_;
  };
  /**
   * Get the feature's style. Will return what was provided to the
   * {@link module:ol/Feature~Feature#setStyle} method.
   * @return {import("./style/Style.js").StyleLike|undefined} The feature style.
   * @api
   */


  Feature.prototype.getStyle = function () {
    return this.style_;
  };
  /**
   * Get the feature's style function.
   * @return {import("./style/Style.js").StyleFunction|undefined} Return a function
   * representing the current style of this feature.
   * @api
   */


  Feature.prototype.getStyleFunction = function () {
    return this.styleFunction_;
  };
  /**
   * @private
   */


  Feature.prototype.handleGeometryChange_ = function () {
    this.changed();
  };
  /**
   * @private
   */


  Feature.prototype.handleGeometryChanged_ = function () {
    if (this.geometryChangeKey_) {
      (0, _events.unlistenByKey)(this.geometryChangeKey_);
      this.geometryChangeKey_ = null;
    }

    var geometry = this.getGeometry();

    if (geometry) {
      this.geometryChangeKey_ = (0, _events.listen)(geometry, _EventType["default"].CHANGE, this.handleGeometryChange_, this);
    }

    this.changed();
  };
  /**
   * Set the default geometry for the feature.  This will update the property
   * with the name returned by {@link module:ol/Feature~Feature#getGeometryName}.
   * @param {Geometry|undefined} geometry The new geometry.
   * @api
   * @observable
   */


  Feature.prototype.setGeometry = function (geometry) {
    this.set(this.geometryName_, geometry);
  };
  /**
   * Set the style for the feature to override the layer style.  This can be a
   * single style object, an array of styles, or a function that takes a
   * resolution and returns an array of styles. To unset the feature style, call
   * `setStyle()` without arguments or a falsey value.
   * @param {import("./style/Style.js").StyleLike} [opt_style] Style for this feature.
   * @api
   * @fires module:ol/events/Event~BaseEvent#event:change
   */


  Feature.prototype.setStyle = function (opt_style) {
    this.style_ = opt_style;
    this.styleFunction_ = !opt_style ? undefined : createStyleFunction(opt_style);
    this.changed();
  };
  /**
   * Set the feature id.  The feature id is considered stable and may be used when
   * requesting features or comparing identifiers returned from a remote source.
   * The feature id can be used with the
   * {@link module:ol/source/Vector~VectorSource#getFeatureById} method.
   * @param {number|string|undefined} id The feature id.
   * @api
   * @fires module:ol/events/Event~BaseEvent#event:change
   */


  Feature.prototype.setId = function (id) {
    this.id_ = id;
    this.changed();
  };
  /**
   * Set the property name to be used when getting the feature's default geometry.
   * When calling {@link module:ol/Feature~Feature#getGeometry}, the value of the property with
   * this name will be returned.
   * @param {string} name The property name of the default geometry.
   * @api
   */


  Feature.prototype.setGeometryName = function (name) {
    this.removeChangeListener(this.geometryName_, this.handleGeometryChanged_);
    this.geometryName_ = name;
    this.addChangeListener(this.geometryName_, this.handleGeometryChanged_);
    this.handleGeometryChanged_();
  };

  return Feature;
}(_Object["default"]);
/**
 * Convert the provided object into a feature style function.  Functions passed
 * through unchanged.  Arrays of Style or single style objects wrapped
 * in a new feature style function.
 * @param {!import("./style/Style.js").StyleFunction|!Array<import("./style/Style.js").default>|!import("./style/Style.js").default} obj
 *     A feature style function, a single style, or an array of styles.
 * @return {import("./style/Style.js").StyleFunction} A style function.
 */


function createStyleFunction(obj) {
  if (typeof obj === 'function') {
    return obj;
  } else {
    /**
     * @type {Array<import("./style/Style.js").default>}
     */
    var styles_1;

    if (Array.isArray(obj)) {
      styles_1 = obj;
    } else {
      (0, _asserts.assert)(typeof
      /** @type {?} */
      obj.getZIndex === 'function', 41); // Expected an `import("./style/Style.js").Style` or an array of `import("./style/Style.js").Style`

      var style =
      /** @type {import("./style/Style.js").default} */
      obj;
      styles_1 = [style];
    }

    return function () {
      return styles_1;
    };
  }
}

var _default = Feature;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7QUFHQTs7QUFDQTs7QUFDQTs7QUFDQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQU5BOzs7OztBQVFBOzs7O0FBSUE7Ozs7QUFJQTs7Ozs7Ozs7QUFRQTs7Ozs7QUFLQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBNkNBO0FBQUE7QUFBQTtFQUFzQkE7RUFDcEI7Ozs7Ozs7O0VBTUEsaUJBQVlDLHdCQUFaLEVBQW9DO0lBQXBDLFlBQ0VDLHFCQUFPLElBRFQ7SUFHRTs7Ozs7SUFHQUMsS0FBSSxDQUFDQyxFQUFMO0lBRUE7Ozs7SUFHQUQsS0FBSSxDQUFDRSxJQUFMO0lBRUE7Ozs7SUFHQUYsS0FBSSxDQUFDRyxFQUFMO0lBRUE7Ozs7O0lBSUFILEtBQUksQ0FBQ0ksR0FBTCxHQUFXQyxTQUFYO0lBRUE7Ozs7O0lBSUFMLEtBQUksQ0FBQ00sYUFBTCxHQUFxQixVQUFyQjtJQUVBOzs7Ozs7SUFLQU4sS0FBSSxDQUFDTyxNQUFMLEdBQWMsSUFBZDtJQUVBOzs7OztJQUlBUCxLQUFJLENBQUNRLGNBQUwsR0FBc0JILFNBQXRCO0lBRUE7Ozs7O0lBSUFMLEtBQUksQ0FBQ1Msa0JBQUwsR0FBMEIsSUFBMUI7O0lBRUFULEtBQUksQ0FBQ1UsaUJBQUwsQ0FBdUJWLEtBQUksQ0FBQ00sYUFBNUIsRUFBMkNOLEtBQUksQ0FBQ1csc0JBQWhEOztJQUVBLElBQUliLHdCQUFKLEVBQThCO01BQzVCLElBQ0U7TUFDRTtNQUFrQkEsd0JBQUQsQ0FBMkJjLHFCQUQ5QyxLQUVNLFVBSFIsRUFJRTtRQUNBLElBQU1DLFFBQVE7UUFBRztRQUF5QmYsd0JBQTFDOztRQUNBRSxLQUFJLENBQUNjLFdBQUwsQ0FBaUJELFFBQWpCO01BQ0QsQ0FQRCxNQU9PO1FBQ0w7UUFDQSxJQUFNRSxVQUFVLEdBQUdqQix3QkFBbkI7O1FBQ0FFLEtBQUksQ0FBQ2dCLGFBQUwsQ0FBbUJELFVBQW5CO01BQ0Q7SUFDRjs7O0VBQ0Y7RUFFRDs7Ozs7Ozs7RUFNQUU7SUFDRSxJQUFNQyxLQUFLO0lBQUc7SUFDWixJQUFJRCxPQUFKLENBQVksS0FBS0UsYUFBTCxLQUF1QixLQUFLQyxhQUFMLEVBQXZCLEdBQThDLElBQTFELENBREY7SUFHQUYsS0FBSyxDQUFDRyxlQUFOLENBQXNCLEtBQUtDLGVBQUwsRUFBdEI7SUFDQSxJQUFNVCxRQUFRLEdBQUcsS0FBS1UsV0FBTCxFQUFqQjs7SUFDQSxJQUFJVixRQUFKLEVBQWM7TUFDWkssS0FBSyxDQUFDSixXQUFOO01BQWtCO01BQXlCRCxRQUFRLENBQUNLLEtBQVQsRUFBM0M7SUFDRDs7SUFDRCxJQUFNTSxLQUFLLEdBQUcsS0FBS0MsUUFBTCxFQUFkOztJQUNBLElBQUlELEtBQUosRUFBVztNQUNUTixLQUFLLENBQUNRLFFBQU4sQ0FBZUYsS0FBZjtJQUNEOztJQUNELE9BQU9OLEtBQVA7RUFDRCxDQWREO0VBZ0JBOzs7Ozs7Ozs7O0VBUUFEO0lBQ0U7TUFBTztNQUFtQyxLQUFLVSxHQUFMLENBQVMsS0FBS3JCLGFBQWQ7SUFBMUM7RUFDRCxDQUZEO0VBSUE7Ozs7Ozs7OztFQU9BVztJQUNFLE9BQU8sS0FBS2IsR0FBWjtFQUNELENBRkQ7RUFJQTs7Ozs7Ozs7O0VBT0FhO0lBQ0UsT0FBTyxLQUFLWCxhQUFaO0VBQ0QsQ0FGRDtFQUlBOzs7Ozs7OztFQU1BVztJQUNFLE9BQU8sS0FBS1YsTUFBWjtFQUNELENBRkQ7RUFJQTs7Ozs7Ozs7RUFNQVU7SUFDRSxPQUFPLEtBQUtULGNBQVo7RUFDRCxDQUZEO0VBSUE7Ozs7O0VBR0FTO0lBQ0UsS0FBS1csT0FBTDtFQUNELENBRkQ7RUFJQTs7Ozs7RUFHQVg7SUFDRSxJQUFJLEtBQUtSLGtCQUFULEVBQTZCO01BQzNCLDJCQUFjLEtBQUtBLGtCQUFuQjtNQUNBLEtBQUtBLGtCQUFMLEdBQTBCLElBQTFCO0lBQ0Q7O0lBQ0QsSUFBTUksUUFBUSxHQUFHLEtBQUtVLFdBQUwsRUFBakI7O0lBQ0EsSUFBSVYsUUFBSixFQUFjO01BQ1osS0FBS0osa0JBQUwsR0FBMEIsb0JBQ3hCSSxRQUR3QixFQUV4QmdCLHNCQUFVQyxNQUZjLEVBR3hCLEtBQUtDLHFCQUhtQixFQUl4QixJQUp3QixDQUExQjtJQU1EOztJQUNELEtBQUtILE9BQUw7RUFDRCxDQWZEO0VBaUJBOzs7Ozs7Ozs7RUFPQVgsMENBQVlKLFFBQVosRUFBb0I7SUFDbEIsS0FBS21CLEdBQUwsQ0FBUyxLQUFLMUIsYUFBZCxFQUE2Qk8sUUFBN0I7RUFDRCxDQUZEO0VBSUE7Ozs7Ozs7Ozs7O0VBU0FJLHVDQUFTZ0IsU0FBVCxFQUFrQjtJQUNoQixLQUFLMUIsTUFBTCxHQUFjMEIsU0FBZDtJQUNBLEtBQUt6QixjQUFMLEdBQXNCLENBQUN5QixTQUFELEdBQ2xCNUIsU0FEa0IsR0FFbEI2QixtQkFBbUIsQ0FBQ0QsU0FBRCxDQUZ2QjtJQUdBLEtBQUtMLE9BQUw7RUFDRCxDQU5EO0VBUUE7Ozs7Ozs7Ozs7O0VBU0FYLG9DQUFNa0IsRUFBTixFQUFRO0lBQ04sS0FBSy9CLEdBQUwsR0FBVytCLEVBQVg7SUFDQSxLQUFLUCxPQUFMO0VBQ0QsQ0FIRDtFQUtBOzs7Ozs7Ozs7RUFPQVgsOENBQWdCbUIsSUFBaEIsRUFBb0I7SUFDbEIsS0FBS0Msb0JBQUwsQ0FBMEIsS0FBSy9CLGFBQS9CLEVBQThDLEtBQUtLLHNCQUFuRDtJQUNBLEtBQUtMLGFBQUwsR0FBcUI4QixJQUFyQjtJQUNBLEtBQUsxQixpQkFBTCxDQUF1QixLQUFLSixhQUE1QixFQUEyQyxLQUFLSyxzQkFBaEQ7SUFDQSxLQUFLQSxzQkFBTDtFQUNELENBTEQ7O0VBTUY7QUFBQyxDQXhPRCxDQUFzQjJCLGtCQUF0QjtBQTBPQTs7Ozs7Ozs7OztBQVFNLFNBQVVKLG1CQUFWLENBQThCSyxHQUE5QixFQUFpQztFQUNyQyxJQUFJLE9BQU9BLEdBQVAsS0FBZSxVQUFuQixFQUErQjtJQUM3QixPQUFPQSxHQUFQO0VBQ0QsQ0FGRCxNQUVPO0lBQ0w7OztJQUdBLElBQUlDLFFBQUo7O0lBQ0EsSUFBSUMsS0FBSyxDQUFDQyxPQUFOLENBQWNILEdBQWQsQ0FBSixFQUF3QjtNQUN0QkMsUUFBTSxHQUFHRCxHQUFUO0lBQ0QsQ0FGRCxNQUVPO01BQ0wscUJBQU87TUFBUTtNQUFrQkEsR0FBRCxDQUFNSSxTQUEvQixLQUE4QyxVQUFyRCxFQUFpRSxFQUFqRSxFQURLLENBQ2lFOztNQUN0RSxJQUFNbkIsS0FBSztNQUFHO01BQW1EZSxHQUFqRTtNQUNBQyxRQUFNLEdBQUcsQ0FBQ2hCLEtBQUQsQ0FBVDtJQUNEOztJQUNELE9BQU87TUFDTCxPQUFPZ0IsUUFBUDtJQUNELENBRkQ7RUFHRDtBQUNGOztlQUNjdkIsTyIsIm5hbWVzIjpbIl9fZXh0ZW5kcyIsIm9wdF9nZW9tZXRyeU9yUHJvcGVydGllcyIsIl9zdXBlciIsIl90aGlzIiwib24iLCJvbmNlIiwidW4iLCJpZF8iLCJ1bmRlZmluZWQiLCJnZW9tZXRyeU5hbWVfIiwic3R5bGVfIiwic3R5bGVGdW5jdGlvbl8iLCJnZW9tZXRyeUNoYW5nZUtleV8iLCJhZGRDaGFuZ2VMaXN0ZW5lciIsImhhbmRsZUdlb21ldHJ5Q2hhbmdlZF8iLCJnZXRTaW1wbGlmaWVkR2VvbWV0cnkiLCJnZW9tZXRyeSIsInNldEdlb21ldHJ5IiwicHJvcGVydGllcyIsInNldFByb3BlcnRpZXMiLCJGZWF0dXJlIiwiY2xvbmUiLCJoYXNQcm9wZXJ0aWVzIiwiZ2V0UHJvcGVydGllcyIsInNldEdlb21ldHJ5TmFtZSIsImdldEdlb21ldHJ5TmFtZSIsImdldEdlb21ldHJ5Iiwic3R5bGUiLCJnZXRTdHlsZSIsInNldFN0eWxlIiwiZ2V0IiwiY2hhbmdlZCIsIkV2ZW50VHlwZSIsIkNIQU5HRSIsImhhbmRsZUdlb21ldHJ5Q2hhbmdlXyIsInNldCIsIm9wdF9zdHlsZSIsImNyZWF0ZVN0eWxlRnVuY3Rpb24iLCJpZCIsIm5hbWUiLCJyZW1vdmVDaGFuZ2VMaXN0ZW5lciIsIkJhc2VPYmplY3QiLCJvYmoiLCJzdHlsZXNfMSIsIkFycmF5IiwiaXNBcnJheSIsImdldFpJbmRleCJdLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJzcmMvRmVhdHVyZS5qcyJdLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==